import React from "react";

import { ToneSegments } from "../../../../components/FormPanel";
import {
  Card,
  CardLabel,
  HelperText,
} from "../../../../components/MobileForm/styles";
import { FormMoneyInput, InputDate } from "../../../../components/Input";
import { localToday } from "../../../../utils";
import { validateAmount } from "../tradeValidation";
import { MobileChargeField } from "../MobileChargeField";
import { MobileInterestDirectionField } from "../MobileInterestDirectionField";
import { MobileNoteField } from "../MobileNoteField";
import { ACTION_SEGMENTS } from "./constants";
import { MobileAccountCashFormProps } from "./types";

export const MobileAccountCashForm: React.FC<MobileAccountCashFormProps> = ({
  control,
  action,
  copy,
  minDate,
  dateRules,
  direction,
  directionError,
  showsTax,
  isSubmitting,
  onActionChange,
  onDirectionChange,
}) => {
  const directionGroupLabel = copy.directionGroupLabel;

  return (
    <>
      <Card>
        <CardLabel as="span">Entry type *</CardLabel>
        <ToneSegments
          groupLabel="Entry type"
          options={ACTION_SEGMENTS}
          selectedValue={action}
          disabled={isSubmitting}
          onChange={(segment) => onActionChange(segment.value)}
        />
      </Card>

      {directionGroupLabel && (
        <Card>
          <MobileInterestDirectionField
            value={direction}
            groupLabel={directionGroupLabel}
            isSubmitting={isSubmitting}
            error={directionError}
            onChange={onDirectionChange}
          />
        </Card>
      )}

      <Card>
        <CardLabel htmlFor="mobile-account-cash-amount">Amount *</CardLabel>
        <FormMoneyInput
          id="mobile-account-cash-amount"
          required
          name="amountEur"
          control={control}
          rules={{ validate: validateAmount }}
          disabled={isSubmitting}
          placeholder="0.00"
          variant="title"
        />
        <HelperText>{copy.amountHelper}</HelperText>
      </Card>

      {showsTax && (
        <Card>
          <MobileChargeField
            id="mobile-account-cash-tax"
            control={control}
            charge="withholdingTax"
            helper={copy.taxHelper ?? ""}
            isSubmitting={isSubmitting}
            taxedIncome="interest"
          />
        </Card>
      )}

      <Card>
        <CardLabel htmlFor="mobile-account-cash-date">Date *</CardLabel>
        <InputDate
          id="mobile-account-cash-date"
          name="date"
          control={control}
          rules={dateRules}
          disabled={isSubmitting}
          minDate={minDate}
          maxDate={localToday()}
          placeholder="YYYY/MM/DD"
        />
        <HelperText>Must be on or after the account's start date.</HelperText>
      </Card>

      <Card>
        <MobileNoteField
          id="mobile-account-cash-note"
          control={control}
          isSubmitting={isSubmitting}
        />
      </Card>
    </>
  );
};
